import ArrowIcon from "../../assets/icons/arrow.svg?react";
import BipodIcon from "../../assets/icons/bipod.svg?react";
import PoleIcon from "../../assets/icons/pole.svg?react";
import TripodIcon from "../../assets/icons/tripod.svg?react";
import RopeIcon from "../../assets/icons/rope.svg?react";
import PolypedestraIcon from "../../assets/icons/polypedestra.svg?react";
import LengthIcon from "../../assets/icons/lenghttool.svg?react";
import AxeIcon from "../../assets/icons/axe.svg?react";
import React, { useContext, useState } from "react";
import { Tool } from "./ToolbarItem";
import { RendererContext } from "../contexts/rendererContext";
import { UserContext } from "../contexts/userContext";
import { useParams } from "react-router-dom";
import { useDeviceSize } from "../hooks/useDeviceSize";
import ProjectStatusButton from "./buildingBlocks/ProjectStatusButton";
import NavigationBar from "./NavigationBar";

const Toolbar = () => {
  const rendererContext = useContext(RendererContext);
  const viewer = rendererContext.viewer;
  const [selectedTool, setSelectedTool] = useState("selectiontool");

  const { smDevice } = useDeviceSize();

  const userContext = React.useContext(UserContext);
  const { userId: projectOwnerId } = useParams();
  const editingAllowed = userContext.user.id === projectOwnerId;

  if (!userContext.user.id) return <NavigationBar />;
  if (!editingAllowed) return <NavigationBar />;

  return (
    <NavigationBar callToAction={<ProjectStatusButton />}>
      {!smDevice && (
        <>
          <Tool
            style={{ margin: "0 3rem 0 0" }}
            active={selectedTool === "selectiontool"}
            disabled={false}
            icon={ArrowIcon}
            onClick={() => {
              viewer?.inputHandler.onActivateTool("selectiontool");
              setSelectedTool("selectiontool");
            }}
          />
          <Tool
            active={selectedTool === "poletool"}
            disabled={!editingAllowed}
            icon={PoleIcon}
            onClick={() => {
              viewer?.inputHandler.onActivateTool("poletool");
              setSelectedTool("poletool");
            }}
          />
          <Tool
            style={{ margin: "0 3rem 0 0" }}
            active={selectedTool === "transformationtool"}
            disabled={!editingAllowed}
            icon={LengthIcon}
            onClick={() => {
              viewer?.inputHandler.onActivateTool("transformationtool");
              setSelectedTool("transformationtool");
            }}
          />
          <Tool
            active={selectedTool === "bipodtool"}
            disabled={!editingAllowed}
            icon={BipodIcon}
            onClick={() => {
              viewer?.inputHandler.onActivateTool("bipodtool");
              setSelectedTool("bipodtool");
            }}
          />
          <Tool
            active={selectedTool === "tripodtool"}
            disabled={!editingAllowed}
            icon={TripodIcon}
            onClick={() => {
              viewer?.inputHandler.onActivateTool("tripodtool");
              setSelectedTool("tripodtool");
            }}
          />
          <Tool
            style={{ margin: "0 3rem 0 0" }}
            active={selectedTool === "polypedestratool"}
            disabled={!editingAllowed}
            icon={PolypedestraIcon}
            onClick={() => {
              viewer?.inputHandler.onActivateTool("polypedestratool");
              setSelectedTool("polypedestratool");
            }}
          />
          <Tool
            active={selectedTool === "destructiontool"}
            disabled={!editingAllowed}
            icon={AxeIcon}
            onClick={() => {
              viewer?.inputHandler.onActivateTool("destructiontool");
              setSelectedTool("destructiontool");
            }}
          />
          <Tool
            active={selectedTool === "lashingtool"}
            disabled={!editingAllowed}
            icon={RopeIcon}
            onClick={() => {
              viewer?.inputHandler.onActivateTool("lashingtool");
              setSelectedTool("lashingtool");
            }}
          />
        </>
      )}
    </NavigationBar>
  );
};

export default Toolbar;
